// The settings search, and the strip over an open group: the way back to all
// settings over the group's menu, and a compact search lined up with the page
// title. On the home the search stands alone, larger, over the cards
// (SettingsHome.jsx).
import Chevron from "../ui/Chevron.jsx";
import SearchInput from "../ui/SearchInput.jsx";
import { MENU_COLUMNS } from "./SettingsGroup.jsx";

export function SearchField({ value, onChange, inputRef, large = false }) {
    return (
        <SearchInput
            id="settings-search"
            inputRef={inputRef}
            value={value}
            onChange={onChange}
            placeholder="Search settings"
            size={large ? "lg" : "sm"}
            className={large ? "w-full" : "h-[34px] w-[340px] max-w-full max-[639px]:w-full"}
        />
    );
}

// The strip takes the open group's two columns (SettingsGroup.jsx): the way
// back over its menu, the search over its page.
export default function SettingsTop({ onBack, query, onQuery, searchRef }) {
    return (
        <header className={`grid shrink-0 items-center gap-y-[8px] pb-[10px] pt-[14px] ${MENU_COLUMNS} max-[799px]:grid-cols-1`}>
            <button type="button" onClick={onBack} className="inline-flex w-max items-center gap-[8px] pl-[10px] text-[13px] text-[color:var(--muted)] transition-colors hover:text-[color:var(--ink)] max-[799px]:pl-0">
                <Chevron back />All settings
            </button>
            <div className="pl-[33px] max-[799px]:pl-0">
                <SearchField value={query} onChange={onQuery} inputRef={searchRef} />
            </div>
        </header>
    );
}
